export function phoneFormatter(phoneNumber?: string): string {
    if (!phoneNumber) return ''

    const formattedPhone = `+${phoneNumber.slice(0, 1)} (${phoneNumber.slice(1, 4)}) ${phoneNumber.slice(4, 7)}-${phoneNumber.slice(7, 9)}-${phoneNumber.slice(9, 11)}`

    return formattedPhone
}
